<template>
    <add-edit-vessel-type></add-edit-vessel-type>
</template>

<script>
import AddEditVesselType from "@/layouts/components/masters/vesselTypes/addedit-vesselType.vue";
export default {
 components : {
   AddEditVesselType
 },
};
</script>